<template>
  <div class="device-detail-supplies">

    <div class="table-bd">
      <div class="search-content">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <el-form-item
              style="float: right"
              v-if="funcView.device_detail_supplies_export"
            >
              <el-button
                type="info"
                @click="onExport"
              >
                <i class="icon icon-export-excel"></i>
                {{ $t('Common.com_export') }}
              </el-button>
            </el-form-item>
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('device_detail_supplies.zjmcljmc')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <custom-table
        :data="tableList"
        tableCode="portal_device_resume"
        height="500px"
        :filterArr="filterArr"
        @filter="filterChange"
        @sort="sortChange"
        @column="setColumn"
        :slots="['currentVal', 'remainVal', 'remainPercent']"
      >
        <template v-slot:currentVal="scope">
          <span type="text" :style="{ color:  scope.row.currentVal >= scope.row.criticalVal? 'red-text' : 'green-text' }">{{ scope.row.currentVal||0 }}</span>
        </template>
        <template v-slot:remainVal="scope">
          <span type="text" :style="{ color: scope.row.currentVal >= scope.row.criticalVal ? 'red-text' : 'green-text' }">{{scope.row.remainVal}}</span>
        </template>
        <template v-slot:remainPercent="scope">
          <span type="text" :class="scope.row.currentVal >= scope.row.criticalVal ? 'red-text' : 'green-text'" >{{scope.row.remainPercent || '-' }}</span>
        </template>

    </custom-table>
      <!-- <div class="table-footer">
        <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div> -->
    </div>

  </div>
</template>

<script>
// import moment from 'moment';
import apis from '@/utils/apis';

export default {
  name: 'deviceDetailSupplies',
  props: {
    deviceInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {},
  data() {
    return {
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        search: '',
        orderBy: '',
        orderType: '',
        deviceId: '',
        workOrderType: '20',
      },
      tableList: [],
      totalRows: null,
    };
  },
  watch: {},

  mounted() {
    this.getFuncView('/other/device', () => {
      this.getTableList();
    });

  },
  methods: {

    getTableList() {
      this.formSearch.bodyNum = this.deviceInfo.bodyNum;
      this.$getJSON(apis.DeviceComponentList, this.formSearch).then((res) => {
        this.tableList = res.data;
        // this.totalRows = res.data.total;
      });
    },
    onExport() {
      this.exportTable('DeviceComponentExport', this.formSearch);
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.device-detail-supplies {
  .table-bd {
    background: #ffffff;
    border-radius: 16px;
    padding: 24px 24px 0;
    margin-top: 24px;

  }
 .search-content {
    padding: 0 24px;
    overflow: hidden;
    .btn-content {
      float: left;
    }
    .el-button + .el-button {
      margin-left: 16px;
    }
  }
  .green-text {
    color: green;
  }
  .red-text {
    color: red;
  }
}
</style>
